<template>
  <v-container class="text-center">
    <v-progress-circular
      :size="80"
      :width="7"
      indeterminate
      color="primary"
    ></v-progress-circular>
  </v-container>
</template>

<script>
export default {
  name: "LoadingSpinner"
};
</script>
